import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
import { App } from './App';
import './responsive.css';
import { initAdminSentry } from './observability/sentry';

// Initialise crash reporting before the React tree mounts so any error
// during root render also reaches Sentry.
initAdminSentry();

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#FB3C7F',
          colorInfo: '#FB3C7F',
          colorSuccess: '#10B981',
          colorWarning: '#FFD06A',
          colorError: '#EF4444',
          fontFamily: "'Outfit', system-ui, sans-serif",
          borderRadius: 10,
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
);
